import { Link } from 'react-router-dom';

export function TermsPage() {
  return (
    <div className="min-h-screen bg-[#11111b] text-[#cdd6f4]">
      <div className="max-w-3xl mx-auto px-6 py-10">
        <h1 className="text-3xl font-bold text-white mb-6">Terms of Service</h1>
        <p className="text-sm text-[#a6adc8] mb-8">Last updated: February 7, 2026</p>

        <div className="space-y-5 text-sm leading-7">
          <p className="rounded-md border border-amber-400/30 bg-amber-500/10 px-3 py-2 text-amber-200">
            Test Mode Notice: UI Grace is currently provided in test (beta) mode. Features may change, break, or be
            removed without prior notice.
          </p>
          <p>
            By using UI Grace, you accept these Terms. If you do not accept them, do not use the service.
          </p>
          <p>
            You are solely responsible for prompts, generated content, project data, and API keys provided under your
            account. You confirm you have lawful rights to use any credentials you provide.
          </p>
          <p>
            AI output may be inaccurate, incomplete, or unsuitable. You must review all outputs before any production,
            legal, financial, or commercial use.
          </p>
          <p>
            To the maximum extent permitted by law, the service is provided &quot;as is&quot; without warranties, and
            we are not liable for indirect, incidental, special, or consequential damages, including data loss,
            business interruption, or lost profits.
          </p>
          <p>
            We may suspend access, apply limits, or terminate accounts for abuse, security risk, policy violations, or
            unlawful use. We may update these Terms at any time; continued use means acceptance of updates.
          </p>
        </div>

        <div className="mt-10">
          <Link to="/login" className="text-[#89b4fa] hover:underline text-sm">
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
}
